import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

function createData(organisation) {
  return { organisation };
}

const rows = [
  createData('AISSMS College of Engineering, Pune'),
  createData(' AISSMS Institute of Information Technology, E & TC Department, Pune'),
  createData('Ajeenkya DY Patil University  '),
  createData('Bhartiya Yuva Shakti Trust (BYST)'),
  createData('CHRIST (DEEMED TO BE UNIVERSITY), PUNE LAVASA'),
  createData('Government of Maharashtra - Skill Development, Employment and Entrepreneurship'),
  createData(' D Y Patil PGDM Institute,  Akurdi'),
  createData('D Y Patil University Ambi Pune'),
  createData('D.Y. Patil Institute of Management Studies, Akurdi Pune'),
  createData('Dr. D Y Patil Institute of Management and Research, Pimpri (Dnyaan Prasad Global University School of Management & research. (DPGUSMR)'),
  createData('D Y Patil University , Pune'),
  createData('Dr. Vishwanath Karad MIT WPU, Pune'),
  createData('(Institute of Industrial and Computer Management & research.( IiCMr) MBA'),
  createData('Indira College of Engineering & Management'),
  createData('Institute of Management & Entrepreneurship Development(IMED)'),
  createData('JSPMs Bhivarabai Sawant institute of Technology & Research, Pune'),
  createData('JSPMS BHUIVRABAI SAWANT POLYTECHNIC PUNE'),
  createData('JSPMs Charak College of Pharmacy and Research'),
  createData('JSPMs Imperial College of Engineering and Research Pune Department of MBA'),
  createData('JSPMs Imperial College of Engineering and Research Pune Department of MBA'),
  createData('JSPM\'s Kautilya Institute of Management and Research '),
  createData('JSPM\'s Rajarshi Shahu College of Engineering (RSCOE), Pune'),
  createData('MES Senior College, Pune'),
  createData('MES\'s Institute of Management and career courses (IMCC)'),
  createData('MMMS IMERT'),
  createData('MKSSS\'s SMT Hiraben Nanvati Institute of Management and Research for women,  '),
  createData('PCCOE Centre for Innovation, Incubation & Linkages Forum'),
  createData('Pimpri Chinchwad College of Engineering PCCOE - MCA'),
  createData('Poona Institute of Management Sciences & Entrepreneurship (PIMSE)'),
  createData('Professional Education and Skills'),
  createData('Pune Institute of Computer Technology (PICT)'),
  createData('Ramchandra International Institute Of Management'),
  createData('Skilletz Foundation'),
  createData('Shri Balaji University, Pune'),
  createData('Unique Institute of Management '),
  createData('Vishwakarma Institute of Information Technology, Pune'),
];

export default function MoUTableComp() {
  return (
    <TableContainer component={Paper} sx={{maxWidth:'90%', pl:2, pr:2, bgcolor:'#F5F5F5'}}>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell ><b>Name of Institute</b></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow
              key={row.organisation}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {row.organisation}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}